import { render, staticRenderFns } from "./TransporterDriverDetailAssignments.vue?vue&type=template&id=ab43e180&scoped=true&"
import script from "./TransporterDriverDetailAssignments.vue?vue&type=script&lang=js&"
export * from "./TransporterDriverDetailAssignments.vue?vue&type=script&lang=js&"
import style0 from "./TransporterDriverDetailAssignments.vue?vue&type=style&index=0&id=ab43e180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab43e180",
  null
  
)

export default component.exports